import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppStateFactory } from '../class-app-factory';
import { redirectToEditScreen } from '../appSlice';

export const updateBasicSettings = createAsyncThunk(
  'updateBasicSettings',
  async (_, thunkAPI) => {
    const state: any = thunkAPI.getState();
    const step = await AppStateFactory.updateBasicApplicationSettings(
      state.application.app,
      state.basicSettings,
      state.application.authenticationID,
      state.application.step,
      thunkAPI,
    );
    if (
      (step === process.env.REACT_APP_CONFIGURATION_COMPLETED
        && state.application.app === process.env.REACT_APP_SHOPIFY_NON_PLUS_KEY)
      || (step === process.env.REACT_APP_POLICY_SETTINGS_SCREEN
        && state.application.app !== process.env.REACT_APP_SHOPIFY_NON_PLUS_KEY)
    ) {
      await thunkAPI.dispatch(redirectToEditScreen(true));
    }

    return step;
  },
);
